import type { PlatformUser } from '../types/platformAdmin.types';

export function defaultSupportName(companyName: string): string {
  const name = companyName.trim();
  return name ? `Soporte ${name}` : 'Soporte';
}

export type NotifyCandidate = {
  id: number;
  email: string;
  hasTelegram: boolean;
  /** Usuarios con acceso solo a bots elegidos no ven un bot nuevo. */
  canSeeNewBot: boolean;
};

/** Quiénes pueden recibir el aviso: Admin u Operador activos del cliente. */
export function notifyCandidates(users: PlatformUser[]): NotifyCandidate[] {
  return users
    .filter(user => user.status === 'ACTIVE' && (user.role === 'ADMIN' || user.role === 'OPERATOR'))
    .map(user => ({
      id: user.id,
      email: user.email,
      hasTelegram: Boolean(user.telegramId?.trim()),
      canSeeNewBot: user.botAccessMode !== 'SELECTED_BOTS',
    }));
}
